var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecRev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_680_13620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5C13.4453 14.5 12.9257 14.3957 12.441 14.187C11.9563 13.9783 11.5327 13.6927 11.17 13.33C10.8073 12.9673 10.5217 12.5437 10.313 12.059C10.1043 11.5743 10 11.0547 10 10.5H10.5C10.5 11.475 10.8397 12.3022 11.519 12.9815C12.1983 13.6608 13.0253 14.0003 14 14C14.9747 13.9997 15.8018 13.6602 16.4815 12.9815C17.1612 12.3028 17.5007 11.4757 17.5 10.5C17.4993 9.52434 17.1598 8.69734 16.4815 8.01901C15.8032 7.34067 14.976 7.00101 14 7.00001H13.81L14.623 7.81351L14.269 8.17351L12.846 6.74001L14.2885 5.30701L14.6425 5.66701L13.8095 6.50001H14C14.5547 6.50001 15.0743 6.60434 15.559 6.81301C16.0437 7.02167 16.4673 7.30734 16.83 7.67001C17.1927 8.03267 17.4783 8.45634 17.687 8.94101C17.8957 9.42567 18 9.94534 18 10.5C18 11.0547 17.8957 11.5743 17.687 12.059C17.4783 12.5437 17.1927 12.9675 16.83 13.3305C16.4673 13.6935 16.0437 13.979 15.559 14.187C15.0743 14.395 14.5547 14.4993 14 14.5ZM12.7115 11.846V9.59601H12.0195V9.15401H13.154V11.846H12.7115ZM14.3465 11.846C14.2045 11.846 14.0857 11.7982 13.99 11.7025C13.8943 11.6068 13.8463 11.488 13.846 11.346V9.65401C13.846 9.51234 13.894 9.39351 13.99 9.29751C14.086 9.20151 14.2047 9.15367 14.346 9.15401H15.231C15.3727 9.15401 15.4913 9.20184 15.587 9.29751C15.6827 9.39317 15.7307 9.51201 15.731 9.65401V11.346C15.731 11.4877 15.683 11.6065 15.587 11.7025C15.491 11.7985 15.3723 11.8463 15.231 11.846H14.3465ZM14.404 11.404H15.173C15.2117 11.404 15.2405 11.3943 15.2595 11.375C15.2785 11.3557 15.2882 11.3268 15.2885 11.2885V9.71151C15.2885 9.67317 15.2788 9.64434 15.2595 9.62501C15.2402 9.60567 15.2113 9.59601 15.173 9.59601H14.404C14.3653 9.59601 14.3363 9.60567 14.317 9.62501C14.2977 9.64434 14.2882 9.67317 14.2885 9.71151V11.2885C14.2885 11.3268 14.298 11.3557 14.317 11.375C14.3363 11.3943 14.3653 11.404 14.404 11.404Z",
    fill: "#3D4C5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_680_13620",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_680_13620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_680_13620",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecRev);
export default __webpack_public_path__ + "static/media/rec-rev.4c2d6c3e233c134624678b8768b94948.svg";
export { ForwardRef as ReactComponent };